<template>
    <div class='bill-terms'>
        <p>You will not be charged until after your free trial. After your free trial ends on <span v-text="trialEndDateFromNow()"></span> and any promotional rates have been applied, you will be charged for membership annually on a recurring basis. If you qualify for booking credit, it will be applied to your account within 24 hours. You may cancel at any time by visiting your payment settings in your account. By clicking ‘Start My Free Trial’ you agree to our&nbsp;<strong><a href="/page/terms" rel="noopener noreferrer nofollow">Terms of Service</a></strong>.</p>
    </div>
</template>
<script>

import Helpers from "@/mixins/Helpers"

export default {
    mixins:[Helpers]
}
</script>